import { Component, Input, OnInit } from '@angular/core';
import { MultiDropdownQuestionV3 } from '../../../classes/question-multiDropdown';
import { QuestionOptionV3 } from '../../../models/dynamic-form-v3.models';
import { QuestionBaseV3ComponentDirective } from '../question-base.component';

@Component({
  selector: 'bepatient-input-multi-dropdown-v3',
  templateUrl: './input-multiDropdown.component.html',
  styleUrls: ['./input-multiDropdown.component.scss'],
  standalone: false
})
export class InputMultiDropdownComponentV3
  extends QuestionBaseV3ComponentDirective
  implements OnInit
{
  @Input() question: MultiDropdownQuestionV3;
  @Input() color: string;

  selectedChips: QuestionOptionV3[];
  customPopoverOptions: any = {
    cssClass: 'bepatient_dynamic_form_multiSelect_popover',
    mode: 'md'
  };

  get value() {
    return this.formGroup.get(this.question.key).value;
  }

  ngOnInit(): void {
    this.selectedChips = this.getChipsSelected();

    this.formGroup.valueChanges.subscribe(() => {
      this.selectedChips = this.getChipsSelected();
    });
  }

  getChipsSelected(): QuestionOptionV3[] {
    return this.question.options.filter(option =>
      this.formGroup.get(this.question.key).value.includes(option.value)
    );
  }

  selectChip(event: any): void {
    this.formGroup.patchValue(
      { [this.question.key]: event.detail.value },
      {
        emitEvent: false
      }
    );
  }

  deleteChip(chip: QuestionOptionV3): void {
    const filteredChips = this.formGroup
      .get(this.question.key)
      .value.filter(value => value !== chip.value);

    this.formGroup.patchValue({ [this.question.key]: filteredChips });
  }
}
